import { render, staticRenderFns } from "./weChatPush.vue?vue&type=template&id=1508a072&"
import script from "./weChatPush.vue?vue&type=script&lang=js&"
export * from "./weChatPush.vue?vue&type=script&lang=js&"
import style0 from "./weChatPush.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports